import { render, staticRenderFns } from "./TestPage.vue?vue&type=template&id=2ec139ae&scoped=true&lang=true&"
import script from "./TestPage.vue?vue&type=script&lang=js&"
export * from "./TestPage.vue?vue&type=script&lang=js&"
import style0 from "./TestPage.vue?vue&type=style&index=0&id=2ec139ae&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec139ae",
  null
  
)

export default component.exports